import { format as originalFormat } from 'date-fns';
import { memo, useCallback, useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import { toast } from 'react-toastify';

import { useMutationPostCreateFlightResourcesAllocation, useQueryGetGetFlights } from '../../../backend';
import { errorToastConfig } from '../../../config/constants';
import { ganttDayFormat } from '../RmsContent/Gantt/gantt.constants';
import { useRmsGanttValue } from '../RmsContent/RmsContext';
import { ResourcesAllocationForm } from './ResourcesAllocationForm';
import { ResourcesAllocationResults } from './ResourcesAllocationResults';

export interface ResourcesAllocateFormValues {
    onlyNotAllocated: boolean;
}

export const ResourcesAllocationPopin = memo(function ResourcesAllocationPopin({ onClose }: { onClose: () => void }) {
    const resourceType = useRmsGanttValue('resourceType');
    const day = useRmsGanttValue('day');
    const { data: ganttDto } = useQueryGetGetFlights({
        selectedDay: originalFormat(day, ganttDayFormat),
        selectedResourceType: resourceType,
    });
    const turnarounds = ganttDto?.turnarounds;
    const {
        mutateAsync: autoAllocate,
        data: allocationResponse,
        isLoading,
    } = useMutationPostCreateFlightResourcesAllocation({
        onError: () => {
            toast(<FormattedMessage id={'schedule.allocate.errorToast'} />, errorToastConfig);
        },
    });

    const onSubmit = useCallback(
        (values: ResourcesAllocateFormValues) => {
            autoAllocate({
                selectedDay: originalFormat(day, ganttDayFormat),
                selectedResourceType: resourceType,
                resourceAllocationRequestDto: {
                    turnarounds: turnarounds,
                    onlyNotAllocated: values.onlyNotAllocated,
                },
            });
        },
        [autoAllocate, day, resourceType, turnarounds],
    );

    const resourcesAllocateFormInitialValues = useMemo(
        () => ({
            onlyNotAllocated: true,
        }),
        [],
    );

    return allocationResponse ? (
        <ResourcesAllocationResults results={allocationResponse} onClose={onClose} turnarounds={turnarounds} />
    ) : (
        <ResourcesAllocationForm
            onSubmit={onSubmit}
            onClose={onClose}
            isLoading={isLoading}
            initialValues={resourcesAllocateFormInitialValues}
        />
    );
});
